import { initStore } from "../store";

const configureStore = () => {
  const actions = {
    // TOGGLE_FAV: (curState, productId) => {
    //   const prodIndex = curState.products.findIndex((p) => p.id === productId);
    //   const newFavStatus = !curState.products[prodIndex].isFavorite;
    //   const updatedProducts = [...curState.products];
    //   updatedProducts[prodIndex] = {
    //     ...curState.products[prodIndex],
    //     isFavorite: newFavStatus,
    //   };
    //   return { products: updatedProducts };
    // },
    ADD_ORDERITEM: (currentState, product, quanity) => {},
    DELETE_ORDERITEM: (currentState, product) => {},
    DECREASE_ORDERITEM: (currentState, product) => {},
  };
  initStore(actions, {
    shoppingBasket: {
      totalPrice: null,
      totalDiscount: null,
      items: [],
    },
  });
};

export default configureStore;
